const discovery = {
  namespace: "15min",
  calLink: "genesis-mateo-fcqr5a/15min",
};
const parentCoaching = {
  namespace: "30min",
  calLink: "genesis-mateo-fcqr5a/30min",
};
const homeRoutine = {
  namespace: "home-routine-coaching",
  calLink: "genesis-mateo-fcqr5a/home-routine-coaching",
};
const school = {
  namespace: "school-collaboration-support",
  calLink: "genesis-mateo-fcqr5a/school-collaboration-support",
};
const virtualFamily = {
  namespace: "virtual-family-support-session",
  calLink: "genesis-mateo-fcqr5a/virtual-family-support-session",
};

export const CAL_LINKS = {
  discovery,
  "parent-coaching": parentCoaching,
  "home-routine": homeRoutine,
  "home-routine-coaching": homeRoutine,
  school,
  "school-collaboration": school,
  "virtual-coaching": virtualFamily,
};
